import * as React from "react";
import MuiIconButton from "@material-ui/core/IconButton";
import { ButtonColor, ButtonSize } from "../Button";
import type { UiBaseProps, UiElement } from "../uiProps.utils";

export enum IconButtonEdge {
  START = "start",
  END = "end",
}

export type IconButtonProps = UiBaseProps & {
  color?: ButtonColor;
  size?: ButtonSize.SMALL | ButtonSize.MEDIUM;
  // Pulls the button out by its padding so the icon lines up with the bar's edge.
  edge?: IconButtonEdge;
  disabled?: boolean;
  as?: UiElement;
  tabIndex?: number;
  title?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
};

export const IconButton: React.FC<IconButtonProps> = ({ as, ...rest }) => (
  <MuiIconButton {...(as ? { component: as as React.ElementType } : {})} {...rest} />
);
